module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_null.6229020a.png";